import { useTranslation } from "react-i18next";
import { FaPlay } from "react-icons/fa6";
import { Link } from "react-router-dom";
import video1 from "../assets/img/payment/jevoyageici_1.mp4";
import video2 from "../assets/img/payment/jevoyageici_2.mp4";
import videoPayment from "../assets/img/payment/jevoyageici-payment.mp4";
import passengerImg from "../assets/img/Passengers-Information.png";

const steps = [
    {
        step: 1,
        titleKey: "tutStep1Title",
        descKey: "tutStep1Desc",
        mediaType: "video",
        mediaSrc: video1,
    },
    {
        step: 2,
        titleKey: "tutStep2Title",
        descKey: "tutStep2Desc",
        mediaType: "video",
        mediaSrc: video2,
    },
    {
        step: 3,
        titleKey: "tutStep3Title",
        descKey: "tutStep3Desc",
        mediaType: "image",
        mediaSrc: passengerImg,
    },
    {
        step: 4,
        titleKey: "tutStep4Title",
        descKey: "tutStep4Desc",
        mediaType: "video",
        mediaSrc: videoPayment,
    },
];

const Tutoriels = () => {
    const { t } = useTranslation();

    return (
        <section className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-16">
            <div className="container mx-auto px-4">
                <div className="text-center mb-14">
                    <div className="inline-flex items-center gap-2 bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
                        <FaPlay size={12} />
                        {t("tutorielsTag") || "Guides vidéo"}
                    </div>
                    <h1 className="text-4xl font-extrabold text-gray-900 mb-4">
                        {t("tutorielsTitle") || "Comment réserver votre billet ?"}
                    </h1>
                    <p className="text-gray-600 text-lg max-w-2xl mx-auto">
                        {t("tutorielsSubtitle") || "Suivez nos tutoriels vidéo étape par étape pour réserver facilement votre vol sur Je Voyage Ici."}
                    </p>
                </div>

                <div className="space-y-16 max-w-5xl mx-auto">
                    {steps.map(({ step, titleKey, descKey, mediaType, mediaSrc }) => (
                        <div
                            key={step}
                            className={`flex flex-col ${step % 2 === 0 ? "lg:flex-row-reverse" : "lg:flex-row"} gap-10 items-center`}
                        >
                            <div className="w-full lg:w-1/2">
                                {mediaType === "video" ? (
                                    <video
                                        className="rounded-2xl w-full shadow-xl"
                                        src={mediaSrc}
                                        controls
                                        playsInline
                                    />
                                ) : (
                                    <img
                                        src={mediaSrc}
                                        alt={t(titleKey)}
                                        className="rounded-2xl w-full shadow-xl object-cover"
                                    />
                                )}
                            </div>

                            <div className="w-full lg:w-1/2 space-y-4">
                                <div className="flex items-center gap-3">
                                    <span className="w-10 h-10 rounded-full bg-green-600 text-white flex items-center justify-center font-bold text-lg flex-shrink-0">
                                        {step}
                                    </span>
                                    <h2 className="text-2xl font-bold text-gray-900">
                                        {t(titleKey) || `Étape ${step}`}
                                    </h2>
                                </div>
                                <p className="text-gray-600 leading-relaxed text-base">
                                    {t(descKey) || "Description de cette étape bientôt disponible."}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="mt-20 text-center">
                    <div className="inline-block bg-gradient-to-r from-green-600 to-green-500 rounded-3xl p-10 shadow-2xl max-w-xl w-full">
                        <h3 className="text-2xl font-bold mb-3 text-white">
                            {t("tutorielsCtaTitle") || "Prêt à réserver ?"}
                        </h3>
                        <p className="text-green-100 mb-6">
                            {t("tutorielsCtaDesc") || "Commencez votre recherche de vol dès maintenant."}
                        </p>
                        <Link
                            to="/"
                            className="inline-block bg-white text-green-700 font-bold px-8 py-3 rounded-2xl "
                        >
                            {t("tutorielsCtaBtn") || "Rechercher un vol"}
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Tutoriels;
